import identity from 'lodash/identity';
import * as types from '../../actions/actionTypes';
import addWindowLabel from './addWindowLabel';

const actions = {
  [types.renameLabel.RENAME_LABEL]: addWindowLabel,
};

export default (state = {}, action) => (actions[action.type] || identity)(state, action);
